import JsonError from "constanst/JsonError"

export const splitError = (e: string) => {
    if (!e) {
        return e
    }
    const splitMessage = e.toString().split("RLS:")?.[1] || ''
    const numberError = splitMessage.slice(0, 3)
    return JsonError[`RLS` + numberError]
}